import { Box } from "@mui/material";
import { useContext, useState } from "react";
import { ParagraphText, UBButton } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import { sentenceCase } from "../../../../constants";
import styles from "./EarnMoney.module.css";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import {
  BillPlaceholderIcon,
  RechargePlaceholderIcon,
  VoucherPlaceholderIcon,
} from "../../../../assets/icons/icon";

const MAX_VISIBLE_NETWORKS = 4;

const PLACEHOLDER_ICON_BY_TYPE = {
  easyload: RechargePlaceholderIcon,
  bill: BillPlaceholderIcon,
  voucher: VoucherPlaceholderIcon,
};

const EarnMoney = ({ data }) => {
  const [I18n] = useContext(LanguageContext);
  const { earnMoneyList } = data || {};
  const [failedLogos, setFailedLogos] = useState({});

  return (
    <Box
      className={styles.grid}
      style={{ "--earn-money-columns": (earnMoneyList || []).length || 1 }}
    >
      {(earnMoneyList || []).map((item, index) => {
        const networks = item.networks || [];
        const visibleNetworks = networks.slice(0, MAX_VISIBLE_NETWORKS);
        const PlaceholderIcon = PLACEHOLDER_ICON_BY_TYPE[item.type];
        return (
          <Box className={`${styles.card} ${item.type === 'voucher' ? styles.vochureCardStyle
            : ""}`} key={index}>
            <Box className={styles.cardHeader}>
              <ParagraphText className={styles.cardTitle}>
                {sentenceCase(item.title)}
              </ParagraphText>
              <button
                id={`earn_money_transactions_link_${index}`}
                type="button"
                className={styles.transactionsLink}
                onClick={() => {
                  triggerLogEvent(analytics, "w_earn_tab_switch", { tab: item.title });
                  item.handleItemClick?.();
                }}
              >
                {I18n.transactions}
              </button>
            </Box>

            <Box className={styles.networkRow}>
              {visibleNetworks.map((network, netIndex) => {
                const logoKey = `${index}_${netIndex}`;
                const logoFailed = failedLogos[logoKey];
                return (
                  <button
                    id={`earn_money_network_btn_${index}_${netIndex}`}
                    type="button"
                    className={`${styles.networkIcon} ${network?.active === false ? styles.networkIconDisabled : ""
                      }`}
                    key={netIndex}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (network?.active !== false) {
                        item.handleClick?.(e, network.name, network);
                      }
                    }}
                  >
                    {logoFailed && PlaceholderIcon ? (
                      <PlaceholderIcon title={network.name} />
                    ) : (
                      <img
                        src={network.logo}
                        alt={network.name}
                        title={network.name}
                        onError={() =>
                          setFailedLogos((prev) => ({ ...prev, [logoKey]: true }))
                        }
                      />
                    )}
                  </button>
                );
              })}
            </Box >

            <Box className={styles.cardAction}>
              <UBButton
                title={sentenceCase(item.buttonTitle || I18n.view_details)}
                id={`ServiceCardButton-${index}`}
                onClick={(e) => item.handleClick?.(e)}
                className={`ubButtonStyle ubSecondaryButton textUppercase ${styles.cardActionButton}`}
              />
            </Box>
          </Box >
        );
      })}
    </Box >
  );
};

export default EarnMoney;
